export enum savedConditionsCreateTypes {
  FETCH_SAVED_CONDITIONS_CREATE_REQUEST = "FETCH_SAVED_CONDITIONS_CREATE_REQUEST",
  FETCH_SAVED_CONDITIONS_CREATE_SUCCESS = "FETCH_SAVED_CONDITIONS_CREATE_SUCCESS",
  FETCH_SAVED_CONDITIONS_CREATE_FAILURE = "FETCH_SAVED_CONDITIONS_CREATE_FAILURE",
}